import { ReactNode } from "react";

export const HeaderSubheader = ({
  header,
  subheader,
  className = "",
}: {
  header: ReactNode;
  subheader: ReactNode;
  className?: string;
}) => {
  return (
    <div className={`${className}`}>
      <div className="text-2xl text-pry-dark-green-300 font-bold">{header}</div>
      <div className="mt-1 md:mt-2 text-sm text-pry-dark-green-300/60 font-normal">
        {subheader}
      </div>
    </div>
  );
};
